import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { ROUTES } from 'parameters/index'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { Card, Link, Text, View } from 'reshaped/bundle'

export const Aside = () => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<View width={{ s: '100%', l: 'auto' }} insetTop={{ s: 0, l: -33.75 }}>
			<Card elevated>
				<View direction="column" gap={4}>
					<View>
						<Text variant={{ s: 'title-5', l: 'title-4' }} weight="bold">
							{ResourceUtils(pageResources['about.aside.title']).getPlainTextContent()}
						</Text>
						<Text variant="body-3">
							{ResourceUtils(pageResources['about.aside.description']).getPlainTextContent()}
						</Text>
					</View>
					<View direction="column" gap={4}>
						<View direction="row" gap={4}>
							<InlineSvg
								src={ResourceUtils(pageResources['about.aside.item_1']).getMediaContent().url}
								width={44}
								height={44}
							/>
							<View direction="column">
								<Text variant="body-1" weight="bold">
									{ResourceUtils(pageResources['about.aside.item_1']).getPlainTextContent()}
								</Text>
								<Link variant="plain" href={ROUTES.PERSONAL_LOANS}>
									Get Rates
								</Link>
							</View>
						</View>
						<View direction="row" gap={4}>
							<InlineSvg
								src={ResourceUtils(pageResources['about.aside.item_2']).getMediaContent().url}
								width={44}
								height={44}
							/>
							<View direction="column">
								<Text variant="body-1" weight="bold">
									{ResourceUtils(pageResources['about.aside.item_2']).getPlainTextContent()}
								</Text>
								<Link variant="plain" href={ROUTES.SAVINGS}>
									See Offers
								</Link>
							</View>
						</View>
						<View direction="row" gap={4}>
							<InlineSvg
								src={ResourceUtils(pageResources['about.aside.item_3']).getMediaContent().url}
								width={44}
								height={44}
							/>
							<View direction="column">
								<Text variant="body-1" weight="bold">
									{ResourceUtils(pageResources['about.aside.item_3']).getPlainTextContent()}
								</Text>
								<Link variant="plain" href={ROUTES.CREDIT_CARDS}>
									See Offers
								</Link>
							</View>
						</View>
						<View direction="row" gap={4}>
							<InlineSvg
								src={ResourceUtils(pageResources['about.aside.item_4']).getMediaContent().url}
								width={44}
								height={44}
							/>
							<View direction="column">
								<Text variant="body-1" weight="bold">
									{ResourceUtils(pageResources['about.aside.item_4']).getPlainTextContent()}
								</Text>
								<Link variant="plain" href={ROUTES.LIFE_INSURANCE}>
									See Offers
								</Link>
							</View>
						</View>
						<View direction="row" gap={4}>
							<InlineSvg
								src={ResourceUtils(pageResources['about.aside.item_5']).getMediaContent().url}
								width={44}
								height={44}
							/>
							<View direction="column">
								<Text variant="body-1" weight="bold">
									{ResourceUtils(pageResources['about.aside.item_5']).getPlainTextContent()}
								</Text>
								<Link variant="plain" href={ROUTES.MORTGAGE}>
									See Offers
								</Link>
							</View>
						</View>
					</View>
				</View>
			</Card>
		</View>
	)
}
